interface Social {
  id: number;
  name: string;
  path: string;
}

export const SocialLinks: Array<Social> = [
  {
    id: 1,
    name: "LINKEDIN",
    path: "https://linkedin.com/in/oluwaferanmi-emmanuel-280746270",
  },
  {
    id: 2,
    name: "GITHUB",
    path: "https://github.com/Ferinco",
  },
  {
    id: 3,
    name: "WHATSAPP",
    path: "https://wa.me/+2349138770915",
  },
];
